// extracted by mini-css-extract-plugin
export default {"button":"styles_button__evrG3","spinner":"styles_spinner__PZEsG"};